export const isNativeApp = () =>
  window.Capacitor?.isNativePlatform?.() === true;
